import type { CallAnalysisDTO } from '@marnic/shared';
import { SentimentChip } from '../primitives/SentimentChip';

export function SentimentStrip({ analysis }: { analysis: CallAnalysisDTO }): JSX.Element | null {
  if (!analysis.sentimentOverall && !analysis.sentimentAgent && !analysis.sentimentProspect) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      <SentimentChip label="Overall" sentiment={analysis.sentimentOverall} score={analysis.sentimentOverallScore} />
      <SentimentChip label="Agent" sentiment={analysis.sentimentAgent} score={analysis.sentimentAgentScore} />
      <SentimentChip label="Prospect" sentiment={analysis.sentimentProspect} score={analysis.sentimentProspectScore} />
    </div>
  );
}
